var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"status-box",class:_vm.classes},[(_vm.props.value)?_c('div',{staticClass:"status-box__item status-box__item_success"}):_c('div',{staticClass:"status-box__item status-box__item_error"})])}
var staticRenderFns = []

export { render, staticRenderFns }